(function () {
  'use strict';

  function init() {
    // Accordion toggle
    document.querySelectorAll('.lnf-qa__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qa = btn.closest('.lnf-qa');
        qa.classList.toggle('is-open');
        var expanded = qa.classList.contains('is-open');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Category card anchor smooth scroll
    document.querySelectorAll('[data-lnf-scroll]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('data-lnf-scroll'));
        if (target) {
          e.preventDefault();
          var offset = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      });
    });

    // Search
    var input = document.querySelector('.lnf-search__input');
    var clear = document.querySelector('.lnf-search__clear');
    var noResults = document.querySelector('.lnf-no-results');

    if (!input) return;

    function runSearch(q) {
      q = q.trim().toLowerCase();
      var hasMatch = false;

      document.querySelectorAll('.lnf-accordion-section').forEach(function (section) {
        var sectionHasMatch = false;
        section.querySelectorAll('.lnf-qa').forEach(function (qa) {
          var question = (qa.querySelector('.lnf-qa__question-text') || {}).textContent || '';
          var answer = (qa.querySelector('.lnf-qa__answer-inner') || {}).textContent || '';
          var haystack = (question + ' ' + answer).toLowerCase();

          if (!q || haystack.indexOf(q) !== -1) {
            qa.classList.remove('is-hidden');
            if (q) {
              qa.classList.add('is-open');
              sectionHasMatch = true;
              hasMatch = true;
            } else {
              qa.classList.remove('is-open');
            }
          } else {
            qa.classList.add('is-hidden');
            qa.classList.remove('is-open');
          }
        });

        if (q) {
          section.style.display = sectionHasMatch ? '' : 'none';
        } else {
          section.style.display = '';
        }
      });

      if (q) {
        noResults && noResults.classList.toggle('is-visible', !hasMatch);
      } else {
        noResults && noResults.classList.remove('is-visible');
      }

      clear && clear.classList.toggle('is-visible', !!q);
    }

    input.addEventListener('input', function () {
      runSearch(input.value);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        runSearch('');
        input.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
